<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt" />
              </router-link>
            </li>
            <li>{{ $t('general.authorization') }}</li>
            <li>{{ this.$route.params.id ? $t('general.update_permission') : $t('general.add_new_permission') }}</li>
          </ul>
        </nav>
      </div>

      <div class="card authorization-add-edit-roles" style="padding:1.5rem">
        <div class="uk-margin">
          <label class="uk-form-label">{{ $t('general.permission_heading') }}*</label>
          <input v-model="permissionName" class="uk-input" :placeholder="$t('general.permission_heading')" type="text">
          <p v-if="errors.permissionName" class="error-message">{{ $t('general.this_field_is_required') }}</p>
        </div>

        <div class="uk-margin">
          <label class="uk-form-label">{{ $t('general.connection') }}*</label>
          <input v-model="connectionName" class="uk-input" :placeholder="$t('general.connection')" type="text">
          <p v-if="errors.connectionName" class="error-message">{{ $t('general.this_field_is_required') }}</p>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label style="margin-top:2rem">
              {{ $t('general.permission_types') }}</label>
          </div>

          <div v-for="(permission, index) in permissions_actions" :key="index" class="col-md-2">
            <label>{{ permission.name }}</label>
            <label class="uk-switch">
              <input type="checkbox" :checked="permission.enabled" @click="handleSingleToggle(index, $event)" />
              <div class="uk-switch-slider"></div>
            </label>
          </div>

        </div>

        <!-- Kaydet Butonu -->
        <div class="uk-margin">
          <button class="uk-button uk-button-primary" @click="savePermission">{{ $t('general.save') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RolePermissionActions from "@/view/company/Authorization/components/RolePermissionActions.vue";
import axios from "axios";
export default {
  name: "AddPermission",
  components: { RolePermissionActions },
  data() {
    return {
      page: 'add',
      id: '',
      permissionName: this.$route.params.name ?? '',
      connectionName: '',
      errors: {
        permissionName: false,
        connectionName: false
      },
      permissions_actions: [
        { name: this.$t('general.viewing'), action_key_name: 'view', enabled: false },
        { name: this.$t('general.add_action'), action_key_name: 'add', enabled: false },
        { name: this.$t('general.update_action'), action_key_name: 'update', enabled: false },
        { name: this.$t('general.delete_action'), action_key_name: 'delete', enabled: false }
      ]
    };
  },
  methods: {
    handleSingleToggle(selectedIndex, event) {
      const selected = this.permissions_actions[selectedIndex];
      if (selected.enabled) {
        event.preventDefault();
        return;
      }
      this.permissions_actions = this.permissions_actions.map((item, index) => ({
        ...item,
        enabled: index === selectedIndex
      }));
    },
    fetchPermissions() {
      axios.get(`api/permissions/${this.id}`, {
        headers: this.apiHeaders
      }).then((result) => {
        this.permissionName = result.data?.name
        this.connectionName = result.data?.name
        this.updatePermissionsByName(result.data?.name || '');
      });
    },

    updatePermissionsByName(permissionName) {
      const keywordToActionKey = {
        read: 'view',
        update: 'update',
        create: 'add',
        delete: 'delete'
      };

      this.permissions_actions = this.permissions_actions.map(item => {
        const shouldEnable = Object.entries(keywordToActionKey).some(([keyword, actionKey]) => {
          return permissionName.includes(keyword) && item.action_key_name === actionKey;
        });

        return {
          ...item,
          enabled: shouldEnable ? true : item.enabled
        };
      });
    },
    validateForm() {
      this.errors.permissionName = !this.permissionName.trim();
      this.errors.connectionName = !this.connectionName.trim();
      return !this.errors.permissionName && !this.errors.connectionName;
    },
    savePermission() {
      if (!this.validateForm()) {
        alert(this.$t('general.please_fill_all_required_fields'));
        return;
      }

      const sendData = {
        permissionName: this.permissionName,
        connectionName: this.connectionName,
        permissionsActions: this.permissions_actions
      };

      const config = { headers: this.apiHeaders };
      const isAdd = this.page === 'add';

      const request = isAdd
        ? axios.post('api/permissions', sendData, config)
        : axios.put(`api/permissions/${this.id}`, sendData, config);

      request
        .then((result) => {
          if (result && result.status >= 200 && result.status < 300) {
            const message = isAdd ? this.$t('general.role_saved_successfully') : this.$t('general.role_updated_successfully');
            alert(message);
          }
        })
        .catch((error) => {
          console.error("An error occurred while saving:", error);
          alert("An error occurred. Please try again.");
        });
    }
    ,
    updatePermission(item) {
    }
  },
  mounted() {
    const hash = window.location.hash || '';
    const parts = hash.replace(/^#\//, '').split('/'); // "admin/authorization-add-edit-roles/1" → ["admin", "authorization-add-edit-roles", "1"]
    const lastPart = parts[parts.length - 1];
    const numericId = Number(lastPart);
    if (!isNaN(numericId) && numericId > 0) {
      this.id = numericId;
      this.page = 'edit';
      this.fetchPermissions();
    }
  }
};
</script>

<style scoped>
.uk-switch {
  appearance: none;

  background: #ddd;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
}

.uk-switch:checked {
  background: #1e87f0;
}

.uk-switch:before {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  background: white;
  border-radius: 50%;
  top: 2px;
  left: 2px;
  transition: 0.2s;
}

.uk-switch:checked:before {
  left: 22px;
}

.error-message {
  color: red;
  font-size: 12px;
  margin-top: 5px;
}
</style>
